/* eslint-disable */
export default [
  {
    path: '/admin/wr1-dasboard',
    name: 'wr1-dasboard',
    component: () => import('@/views/dashboard/Admin.vue'),
    meta: {
      pageTitle: 'WR1 Dashboard',
      breadcrumb: [
        {
          text: 'My WR1',
        },
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    },
  },
  /*--------------App---------------*/
  {
    path: '/apps/calendar',
    name: 'apps-calendar',
    component: () => import('@/views/apps/calendar/Calendar.vue'),
  },

  // *===============================================---*
  // *--------- EMAIL & IT'S FILTERS N LABELS -------------------------------*
  // *===============================================---*
  {
    path: '/apps/email',
    name: 'apps-email',
    component: () => import('@/views/apps/email/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
    },
  },
  {
    path: '/apps/email/:folder',
    name: 'apps-email-folder',
    component: () => import('@/views/apps/email/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
      navActiveLink: 'apps-email',
    },
    beforeEnter(to, _, next) {
      if (
        ['sent', 'draft', 'starred', 'spam', 'trash'].includes(to.params.folder)
      )
        next();
      else next({ name: 'error-404' });
    },
  },
  {
    path: '/apps/email/label/:label',
    name: 'apps-email-label',
    component: () => import('@/views/apps/email/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
      navActiveLink: 'apps-email',
    },
    beforeEnter(to, _, next) {
      if (
        ['personal', 'company', 'important', 'private'].includes(
          to.params.label
        )
      )
        next();
      else next({ name: 'error-404' });
    },
  },

  // *===============================================---*
  // *--------- TODO & IT'S FILTERS N TAGS ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/todo',
    name: 'apps-todo',
    component: () => import('@/views/apps/todo/Todo.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },
  {
    path: '/apps/todo/:filter',
    name: 'apps-todo-filter',
    component: () => import('@/views/apps/todo/Todo.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
      navActiveLink: 'apps-todo',
    },
    beforeEnter(to, _, next) {
      if (['important', 'completed', 'deleted'].includes(to.params.filter))
        next();
      else next({ name: 'error-404' });
    },
  },
  {
    path: '/apps/todo/tag/:tag',
    name: 'apps-todo-tag',
    component: () => import('@/views/apps/todo/Todo.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
      navActiveLink: 'apps-todo',
    },
    beforeEnter(to, _, next) {
      if (['team', 'low', 'medium', 'high', 'update'].includes(to.params.tag))
        next();
      else next({ name: 'error-404' });
    },
  },

  // *===============================================---*
  // *--------- CHAT  ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/chat',
    name: 'apps-chat',
    component: () => import('@/views/apps/chat/Chat.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },

  /*--------------App---------------*/
  {
    path: '/public/track-trace',
    name: 'track-trace-public',
    component: () => import('@/views/wr1/track&trade/TrackTrace'),
    meta: {
      layout: 'full',
      resource: 'public',
      action: 'read',
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/others/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'public',
      action: 'read',
    },
  },
  {
    path: '/error-403',
    name: 'misc-not-authorized',
    component: () => import('@/views/others/MiscNotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'public',
      action: 'read',
    },
  },
  // {
  //   path: '/auth/login',
  //   name: 'auth-login',
  //   component: () => import('@/views/auth/Login.vue'),
  //   meta: {
  //     layout: 'full',
  //     resource: 'Auth',
  //     redirectIfLoggedIn: true,
  //   },
  // },
  {
    path: '/auth/login',
    name: 'auth-login',
    component: () => import('@/views/auth/LoginV2.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/auth/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/auth/ForgotPassword-v1.vue'),
    meta: {
      layout: 'full',
      resource: 'public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/auth/reset-password/:token',
    name: 'auth-reset-password',
    component: () => import('@/views/auth/ResetPassword-v1.vue'),
    meta: {
      layout: 'full',
      resource: 'public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/others/coming-soon',
    name: 'misc-coming-soon',
    component: () => import('@/views/others/ComingSoon.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/others/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/others/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/account-setting',
    name: 'pages-account-setting',
    component: () => import('@/views/auth/account-setting/AccountSetting.vue'),
    meta: {
      pageTitle: 'Account Settings',
      breadcrumb: [
        {
          text: 'Page',
        },
        {
          text: 'Account Settings',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/profile',
  //   name: 'pages-profile',
  //   component: () => import('@/views/auth/profile/Profile.vue'),
  //   meta: {
  //     pageTitle: 'Profile',
  //     breadcrumb: [
  //       {
  //         text: 'Page',
  //       },
  //       {
  //         text: 'Profile',
  //         active: true,
  //       },
  //     ],

  //   },
  // },
  {
    path: '/profile',
    name: 'pages-profile',
    component: () => import('@/views/auth/account-setting/AccountSetting.vue'),
    meta: {
      pageTitle: 'Profile',
      breadcrumb: [
        {
          text: 'My Profile',
        },
        {
          text: 'Profile',
          active: true,
        },
      ],
    },
  },
  {
    path: '/faq',
    name: 'pages-faq',
    component: () => import('@/views/faq/Faq.vue'),
    meta: {
      pageTitle: 'Profile',
      breadcrumb: [
        {
          text: 'Page',
        },
        {
          text: 'Profile',
          active: true,
        },
      ],
    },
  },
  // *--------------------------------------------------------------------
  {
    path: '/admin/group-mgmt',
    name: 'group-mgmt',
    component: () => import('@/views/admin/Group.vue'),
    meta: {
      pageTitle: 'Group Management',
      breadcrumb: [
        {
          text: 'Admin',
        },
        {
          text: 'Group Management',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/user-mgmt',
    name: 'user-mgmt',
    props: true,
    component: () => import('@/views/admin/User.vue'),
    meta: {
      pageTitle: 'User Management',
      breadcrumb: [
        {
          text: 'Admin',
        },
        {
          text: 'User Management',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/approve-register',
    name: 'approve-register',
    component: () => import('@/views/admin/ApproveRegister.vue'),
    meta: {
      pageTitle: 'Approve Register',
      breadcrumb: [
        {
          text: 'Admin',
        },
        {
          text: 'Approve Register',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/customer-management',
    name: 'customer-management',
    component: () => import('@/views/admin/CustomerManagement.vue'),
    meta: {
      pageTitle: 'Customer Management',
      breadcrumb: [
        {
          text: 'Admin',
        },
        {
          text: 'Customer Management',
          active: true,
        },
      ],
    },
  },

  {
    path: '/admin/statistician',
    name: 'statistician',
    component: () => import('@/views/admin/Statistician.vue'),
    meta: {
      pageTitle: 'Statistician',
      breadcrumb: [
        {
          text: 'Admin',
        },
        {
          text: 'Statistician',
          active: true,
        },
      ],
    },
  },
];
